import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M2 4L10 16L18 4L2 4Z" fill="#CCCCCC" /></svg>;
const ForwardRef = forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };